import axios from 'axios';
import { baseUrl } from '@/config';
import { downloadFile } from '@/utils/file';

const FILE_URL_PREFIX = 'common/file';
export default {
  /**
   * 업로드할 수 있는 최대 파일 사이즈를 반환한다. (MB 기준)
   * @author Ju
   */
  getFileMaxMbSize() {
    return axios.get(`${baseUrl}/${FILE_URL_PREFIX}/get-file-max-mb-size.do`);
  },
  /**
   * 출력된 엑셀 파일을 다운로드한다.
   * @author Ju
   * @param  {String} fileName 다운로드할 엑셀 파일명
   */
  downloadExportedExcelFile(fileName) {
    const url = `${baseUrl}/${FILE_URL_PREFIX}/download-expoted-excel-file.do`;
    downloadFile(url, { fileName });
  },
  /**
   * 파라미터로 전달된 타입에 맞는 설치 파일을 다운로드한다.
   * @author Ju
   * @param  {[type]} type [description]
   * @return {[type]}      [description]
   */
  downloadSetupFile(type) {
    const url = `${baseUrl}/login/download-setup-file.do`;
    downloadFile(url, { type });
  },
};



// WEBPACK FOOTER //
// ./src/api/common/file.js